// offlineQueue.js — Offline-Puffer für Scoring-Requests
// Speichert POST/PUT/DELETE die beim Netzwerkausfall nicht durchkamen
// in IndexedDB und sendet sie nach Reconnect automatisch nach.

const DB_NAME    = 'tda-offline-queue';
const DB_VERSION = 1;
const STORE      = 'pending';

// Flag: verhindert dass Replay-Requests erneut in die Queue landen
let _replaying = false;
export const flags = {
  get isReplaying() { return _replaying; }
};

// ── DB-Zugriff ────────────────────────────────────────────────────────────────

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'id', autoIncrement: true });
      }
    };
    req.onsuccess = (e) => resolve(e.target.result);
    req.onerror   = (e) => reject(e.target.error);
  });
}

export async function enqueue({ url, method, body, label }) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE, 'readwrite');
    const req = tx.objectStore(STORE).add({ url, method, body, label, ts: Date.now() });
    req.onsuccess = () => resolve(req.result);
    req.onerror   = () => reject(req.error);
  });
}

export async function getAll() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE, 'readonly');
    const req = tx.objectStore(STORE).getAll();
    req.onsuccess = () => resolve(req.result);
    req.onerror   = () => reject(req.error);
  });
}

export async function remove(id) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = resolve;
    tx.onerror    = reject;
  });
}

export async function getPendingCount() {
  const all = await getAll();
  return all.length;
}

// ── Labels ────────────────────────────────────────────────────────────────────

export function labelFromUrl(url, method) {
  if (url.includes('/bruchtest/wertung'))  return 'Bruchtest-Wertung';
  if (url.includes('/formen/wertung'))     return 'Formen-Wertung';
  if (url.includes('/einwaage'))           return 'Einwaage';
  if (url.includes('/kampf') || url.includes('/rumble')) return 'Kampf-Wertung';
  if (url.includes('/wertung'))            return 'Wertung';
  if (method === 'DELETE')                 return 'Löschen';
  return 'Anfrage';
}

// ── Replay ────────────────────────────────────────────────────────────────────

export async function replayAll() {
  const entries = await getAll();
  if (entries.length === 0) return { replayed: 0, failed: 0 };

  _replaying = true;
  window.dispatchEvent(new CustomEvent('offline-queue-syncing', { detail: { total: entries.length } }));

  let replayed = 0;
  let failed   = 0;

  for (const entry of entries) {
    try {
      const resp = await window.fetch(entry.url, {
        method:  entry.method,
        headers: { 'Content-Type': 'application/json' },
        body:    entry.body,
      });

      if (resp.ok) {
        await remove(entry.id);
        replayed++;
        window.dispatchEvent(new Event('offline-queue-changed'));
      } else {
        failed++;
        console.warn(`[OfflineQueue] HTTP ${resp.status} beim Replay von ${entry.url}`);
      }
    } catch (e) {
      failed++;
      console.warn(`[OfflineQueue] Netzwerkfehler beim Replay von ${entry.url}:`, e.message);
    }
  }

  _replaying = false;
  window.dispatchEvent(new CustomEvent('offline-queue-synced', { detail: { replayed, failed } }));
  return { replayed, failed };
}
